<template>
  <div class="employee">

    <div style="display:flex;justify-content:flex-start;margin-bottom:12px;">
      <v-button type="primary" size="medium" @click="pickApplication" v-if="!application.picked_by || application.picked_by === null">Pick Application</v-button>
      <v-button type="warning" size="medium" @click="close" style="margin-left:6px;">Close</v-button>
    </div>

    <v-card :title="`Program Details: ${application.name} - ${application.school.name}`" v-if="application">
      <div class="prog-details">
        <div>
          <p><b><v-icon type="book"></v-icon>&nbsp;Area of study:</b>
          &emsp;{{application.area_of_study}}</p>
          <p ><b><v-icon type="global"></v-icon>&nbsp;Campus:</b>
          &emsp;{{application.school.campus}}</p>
          <p><b><v-icon type="clock-circle-o"></v-icon>&nbsp;Duration:</b>
          &emsp;{{application.duration}}</p>
          <p><b><v-icon type="file"></v-icon>&nbsp;Application Fee:</b>
          &emsp;{{application.application_fee}}</p>
        </div>
        <div>
          <p><b><v-icon type="book"></v-icon>&nbsp;Level of study:</b>
          &emsp;{{application.level_of_study}}</p>
          <p><b><v-icon type="environment-o"></v-icon>&nbsp;Province:</b>
          &emsp;{{application.school.province}}</p>
          <p><b><v-icon type="check-square-o"></v-icon>&nbsp;Test Score Required:</b>
          &emsp;{{application.ielts}}</p>
          <p><b><v-icon type="book"></v-icon>&nbsp;Tution Fee:</b>
          &emsp;{{application.tution_fee}}</p>
        </div>
      </div>

      <div class="prog-details-row">
        <div style="display:flex;justify-content:flex-start;margin-top:8px;">
          <ToggleSwitch :model="application.fall" label="Fall:" />
          <ToggleSwitch :model="application.winter" label="Winter:" />
          <ToggleSwitch :model="application.summer" label="Summer:" />
        </div>
      </div>
    </v-card>

    <v-card v-if="fetchedUser" style="margin-top:14px"
      :title="`Student Details: ${optionsStudyLevels[fetchedUser.academic_details.highest_education]} - ${fetchedUser.academic_details.country_of_education}`">
      <div class="student-details">
        <div>
          <p><b><v-icon type="user"></v-icon>&nbsp;Full Name:</b>
          &emsp;{{fetchedUser.personal_details.first_name}} {{fetchedUser.personal_details.last_name}}</p>
          <p><b><v-icon type="mail"></v-icon>&nbsp;e-Mail:</b>
          &emsp;{{fetchedUser.personal_details.email}}</p>
        </div>
        <div>
          <p><b><v-icon type="user"></v-icon>&nbsp;Date of birth:</b>
          &emsp;{{fetchedUser.personal_details.dob}}</p>
          <p><b><v-icon type="mobile"></v-icon>&nbsp;Phone Number:</b>
          &emsp;{{fetchedUser.personal_details.phone_number}}</p>
        </div>
      </div>
      <p><b><v-icon type="environment-o"></v-icon>&nbsp;Address:</b>
        &emsp;{{fetchedUser.personal_details.address}}</p>

      <h4 style="margin:12px 0 6px;font-weight:bold">English Language Ability</h4>
      <div class="student-details">
        <div>
          <p><b>&nbsp;IELTS Listening Score:</b>
          &emsp;{{fetchedUser.english_language_ability.ielts_listening_score}}</p>
          <p><b>&nbsp;IELTS Reading Score:</b>
          &emsp;{{fetchedUser.english_language_ability.ielts_reading_score}}</p>
          <p><b>&nbsp;TOEFL Score:</b>
          &emsp;{{fetchedUser.english_language_ability.toefl_score}}</p>
        </div>
        <div>
          <p><b>&nbsp;IELTS Speaking Score:</b>
          &emsp;{{fetchedUser.english_language_ability.ielts_speaking_score}}</p>
          <p><b>&nbsp;IELTS Writing Score:</b>
          &emsp;{{fetchedUser.english_language_ability.ielts_writing_score}}</p>
          <p><b>&nbsp;PTE Score:</b>
          &emsp;{{fetchedUser.english_language_ability.pte_score}}</p>
        </div>
      </div>

      <h4 style="margin:12px 0 6px;font-weight:bold">Uploaded documents</h4>
      <div>
        <div v-if="fetchedUser.documents_uploaded && fetchedUser.documents_uploaded.length">
          <div v-for="(doc, index) in fetchedUser.documents_uploaded" :key="index">
            <i class="anticon anticon-paper-clip"></i>
            <a :href="doc.url" target="_blank">{{doc.name}}</a>
            &nbsp;<v-icon type="message" style="cursor:pointer"></v-icon>
          </div>
        </div>
      </div>
    </v-card>

    <div style="display:flex;justify-content:flex-end;margin-top:12px;">
      <v-button type="primary" size="medium" @click="pickApplication" v-if="!application.picked_by || application.picked_by === null">Pick Application</v-button>
      <v-button type="warning" size="medium" @click="close" style="margin-left:6px;">Close</v-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ApplicationView',
  props: ['application', 'close'],
  data () {
    return {
      optionsStudyLevels: {
        G10: 'Grade-10',
        G12: 'Grade-12',
        D1: '1-Year Post-Secondary Certificate',
        D2: '2-Year Undergraduate Diploma',
        D3: '3-Year Undergraduate Advanced Diploma',
        B4: '4-Year Bachelor\'s Degree',
        PG: 'Postgraduate Certificate / Master\'s Degree'
      }
    }
  },
  computed: {
    ...mapGetters([
      'fetchedUser',
      'user'
    ])
  },
  watch: {
    application: {
      handler (val) {
        if (val) {
          this.$store.dispatch('getUserAssignFetched', val.userRef.id)
        }
      },
      immediate: true
    }
  },
  methods: {
    pickApplication () {
      this.$store.dispatch('updateApplicationPickedBy',
        {
          id: this.application.id,
          status: 'Applied',
          payload: {
            picked_by: {
              ref: this.user.ref,
              email: this.user.email,
              full_name: this.user.name || (this.user.first_name + ' ' + this.user.last_name)
            }
          }
        })
      this.close()
    }
  }
}
</script>

<style scoped>
.prog-details {
  width: 65%;
  display: flex;
  justify-content: space-between;
}
.student-details {
  width: 65%;
  display: flex;
  justify-content: space-between;
}
</style>

<style>
.ant-card-head {
  height: 40px;
  line-height: 40px;
  background-color: #404040;
  padding: 0 10px;
}
.ant-card-head-title {
  font-size: 13px;
  color: ivory;
}
.ant-card-body {
  padding: 10px;
}
.ant-collapse-header {
  color: #404040;
  font-size: 13px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/Applications/ApplicationView.vue